// extracted by mini-css-extract-plugin
var _1 = "CategoryTableLayout-modulepageActions__HEBtr PageActions-modulePageActions__lL8Sl";
export { _1 as "pageActions" }
